import { initTimeline } from "./timeline";
import { initServizi } from "./servizi";
import { initContatti } from "./contatti";
import { initContattiPagina } from "./contatti-pagina";
import { initCtaPanel } from "./cta-panel";
import { initArchivioServizi } from "./archivio-servizi";
import { initArchivioCollaborazioni } from "./archivio-collaborazioni";
import { initArchivioRassegnaStampa } from "./archivio-rassegna-stampa";
import { initArchivioImpegnoSociale } from "./archivio-impegno-sociale";
import { initArchivioProgrammiTv } from "./archivio-programmi-tv";
import { initTvMediaTabs } from "./tv-media";
import { initLinksModal } from "./links-modal";
import { initGallery } from "./gallery";
import { initServizioRichiesta } from "./servizio-richiesta";
import { initSuMartinTimeline } from "./su-martin-timeline";
import { initPodcastVideo } from "./podcast-video";

document.addEventListener("DOMContentLoaded", () => {
    initTimeline();
    initServizi();
    initContatti();
    initContattiPagina();
    initCtaPanel();
    initArchivioServizi();
    initArchivioCollaborazioni();
    initArchivioRassegnaStampa();
    initArchivioImpegnoSociale();
    initArchivioProgrammiTv();
    initTvMediaTabs();
    initLinksModal();
    initGallery();
    initServizioRichiesta();
    initSuMartinTimeline();
    initPodcastVideo();
});
